export default __webpack_public_path__ + "static/kb_3_6-13961d77d138b848ee0e5f8d3dacb685.jpg";